// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ButtonClose_wrap__29HjV","button":"ButtonClose_button__3Tfv-","icon":"ButtonClose_icon__2opXX"};